import { photosApi } from "src/services/api";

/**
 * Resolve an image KEY (a layer's `sourceKey`, or a paper's `backgroundImage`)
 * to a signed URL for display. Never persist the returned URL — only the KEY
 * belongs in stored data, since signed URLs expire.
 *
 * Element-image assets ("Slike" stickers, paper photos) live in the shared
 * elements bucket under `elements/…` and resolve via a PUBLIC endpoint, so a
 * first-time guest with no bearer/guest token can still render them. Customer
 * photos use un-prefixed keys and resolve via the auth'd photos route.
 *
 * On any failure this resolves to `undefined` — callers must fall back
 * (e.g. to the paper colour) rather than block or show a blank card.
 */
export async function resolveImageUrl(key: string): Promise<string | undefined> {
  try {
    if (key.startsWith("elements/")) {
      const base = process.env.NEXT_PUBLIC_BASE_URL ?? "";
      const res = await fetch(`${base}/element-image/signed-url?key=${encodeURIComponent(key)}`);
      if (!res.ok) return undefined;
      return ((await res.json()) as { url?: string } | undefined)?.url;
    }
    const res = await photosApi.photoControllerGetDownloadUrl(key);
    return (res.data as unknown as { url?: string } | undefined)?.url;
  } catch {
    return undefined;
  }
}
